<tr @click="openFolder" style="cursor: pointer">
  <td class="text-center"></td>
  <td class="text-center"><img src="@/assets/images/folder.png" class="w-20px" alt=""></td>
  <td class="text-xs text-dark">{{ folder.folder_name }}</td>
  <td class="text-xs text-dark">{{ folder.date_created }}</td>
  <td></td>
  <td>
    <button
      class="btn btn-danger btn-sm text-xxs"
      @click.stop="delete_folder(folder.id)"
    >Delete</button>
    <button class="btn btn-primary btn-sm text-xxs ms-2 d-none" @click.stop="manage_folder_permissions(folder.id)">Manage Folder Permissions</button>
  </td>
</tr>



<!-- Manage Permissions Modal -->
<div class="modal fade" id="manage_folder_permissions_modal" tabindex="-1" aria-labelledby="manageFolderPermissionsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-xs fw-500">Manage Permissions - {{ folder.folder_name }}</h5>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body modal-body-scroll">
        <!-- Add User -->
        <input type="text" v-model="searchQuery" @input="searchUsers" placeholder="Search users by name or email" class="form-control mb-2" />

        <!-- Current Permissions -->
        <div v-for="user in folder_permissions" :key="user.id" class="d-flex align-items-center mb-2">
          <div class="me-2">
            <strong>{{ user.portal_access.first_name }} </strong>
            <br><small>{{ user.portal_access.email }}</small>
            <span v-if="user.is_owner"> (Owner)</span>
          </div>

          <div class="form-check ms-auto me-2">
            <input class="form-check-input" type="checkbox" v-model="user.view" :disabled="user.is_owner"> View
          </div>
          <div class="form-check me-2">
            <input class="form-check-input" type="checkbox" v-model="user.create" :disabled="user.is_owner"> Create
          </div>
          <div class="form-check me-2">
            <input class="form-check-input" type="checkbox" v-model="user.edit" :disabled="user.is_owner"> Edit
          </div>
          <div class="form-check me-2">
            <input class="form-check-input" type="checkbox" v-model="user.delete" :disabled="user.is_owner"> Delete
          </div>

          <button v-if="!user.is_owner" @click="removeUser(user.id)" class="btn btn-sm btn-outline-danger">Remove</button>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary text-xs rounded-5" @click="save_folder_permissions">Save Changes</button>
      </div>
    </div>
  </div>
</div>